import React from 'react'
import Layout from '../components/Layout/Layout'
const Policy = () => {
  return (
    <Layout>Policy</Layout>
  )
}

export default Policy